/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import siteFieldsetTemplate from './site-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.site', [])
    .directive('agSite', Site)
    .name;

/*@ngInject*/
function Site() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            site: '=',
            theForm: '='
        },
        controller: SiteController,
        controllerAs: 'vm',
        templateUrl: siteFieldsetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SiteController($scope, utils) {

    let vm = this;

    vm.flowId = utils.guid();

    vm.imageAdded = imageAdded;
    vm.clearImage = clearImage;

    vm.theForm.updateValidity = function() {
        // Uncomment next 2 lines if image validation needed
        // var valid = vm.site.imageUrl ? true : false;
        // $scope.siteImageForm.$setValidity('imageUrl', valid);
        return true;
    }

    function imageAdded($file) {
        var reader = new FileReader();
        reader.onload = function(event) {
            $scope.$apply(function() {
                if (event.target.result && event.target.result.startsWith('data:image/')) {
                    vm.theForm.$setDirty();
                    vm.site.imageUrl = event.target.result;
                    // vm.theForm.updateValidity(); // Uncomment if image validation needed
                }
            });
        };
        reader.readAsDataURL($file.file);
    }

    function clearImage() {
        vm.theForm.$setDirty();
        vm.site.imageUrl = null;
        // vm.theForm.updateValidity(); // Uncomment if image validation needed
    }
}
